import {
    Component,
    Input,
    SimpleChanges,
    OnChanges,
    inject,
} from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../../common/grid-page.component';
import {
    EmptyCheckOutHistoryGridViewDto,
    EmptyCheckOutStatus,
    ShuntLocationType,
    ShuntPriority,
} from '@services';
import EnumUtils from '../../../../../shared/enum-utils';
import { CapitalCasePipe } from '../../../../../pipes/capital-case.pipe';
import { EmptyCheckOutStatusPipe } from '../../../../../pipes/empty-check-out-status.pipe';
import { CommonModule } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { ShuntPriorityPipe } from 'src/app/pipes/shunt-priority.pipe';

@Component({
    selector: 'app-empty-check-out-history',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        CapitalCasePipe,
        EmptyCheckOutStatusPipe,
        FilterPanelComponent,
        DxFormComponent,
        UserAvatarEmailComponent,
        ShuntPriorityPipe,
    ],
    providers: [ShuntPriorityPipe, EmptyCheckOutStatusPipe],
    templateUrl: './empty-check-out-history.component.html',
})
export class EmptyCheckOutHistoryComponent
    extends GridPageComponent<EmptyCheckOutHistoryGridViewDto>
    implements OnChanges
{
    @Input() number: string | null = null;
    private shuntPriorityPipe = inject(ShuntPriorityPipe);
    private emptyCheckOutStatusPipe = inject(EmptyCheckOutStatusPipe);
    protected override exportName: string = 'Check-Out Report';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource = this.dataSources.emptyCheckOutHistory();

    shuntLocationOptions = EnumUtils.getEnumOptions(ShuntLocationType);

    shuntPriorityOptions = EnumUtils.getEnumOptions(ShuntPriority, (v) =>
        this.shuntPriorityPipe.transform(v),
    );

    statusOptions = EnumUtils.getEnumOptions(EmptyCheckOutStatus, (v) =>
        this.emptyCheckOutStatusPipe.transform(v),
    );

    protected override filterConfig: FilterConfig[] = [
        {
            field: 'employee.name',
            op: 'contains',
            customFilter: this.nameOrEmailFilter,
        },
        { field: 'created', op: '>=' },
        { field: 'status', op: '=' },
        { field: 'location', op: '=' },
        { field: 'number', op: 'contains' },
        { field: 'shuntPriority', op: '=' },
        { field: 'notes', op: 'contains' },
    ];

    constructor() {
        super();
        this.init(EmptyCheckOutHistoryGridViewDto);
    }

    protected getBadgeClass(status: EmptyCheckOutStatus): string {
        return EnumUtils.getEmptyCheckOutStatusBadgeClass(status);
    }

    protected getShuntPriorityBadgeClass(status: ShuntPriority): string {
        return EnumUtils.getShuntPriorityBadgeClass(status);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['number']) {
            this.dataSource = this.dataSources.emptyCheckOutHistory(this.number);
        }
    }
}
